import styles from './error.module.scss'

type Props = {
  error?: string
}

export const ErrorLabel = ({ error }: Props) => {
  if (!error) return null
  return <p className={styles.error}>{error}</p>
}
